// 保留几位小数(四舍五入)
export const numberLimit = (value, decimal) => Number(value || 0).toFixed(decimal);

// 解决数字大小问题--取整数
export const priceIntFilter = value => (value || 0).toString().split(".")[0] + ".";

// 解决数字大小问题--取小数
export const priceFloatFilter = value => (value || 0.0).toString().split(".")[1];
